import { defineComponent } from 'vue'
import {
  AutofixRunStatus,
  AutofixRunPullRequestStatus,
  Maybe,
  AutofixRunConnection
} from '~/types/types'

import RepositoryAutofixRunListGQLQuery from '~/apollo/queries/repository/runs/autofixRun/list.gql'
import { GraphqlQueryResponse } from '~/types/apolloTypes'
import { AutofixListArgs } from '~/types/autofix'

export default defineComponent({
  name: 'AutofixRunMixin',

  methods: {
    async fetchAutofixHistoryRunList({
      provider,
      owner,
      name,
      currentPageNumber,
      limit,
      statusIn,
      prStatusIn,
      refetch,
      q
    }: AutofixListArgs): Promise<Maybe<AutofixRunConnection> | undefined | null> {
      const response: GraphqlQueryResponse = await this.$fetchGraphqlData(
        RepositoryAutofixRunListGQLQuery,
        {
          provider: this.$providerMetaMap[provider].value,
          owner,
          name,
          statusIn: statusIn ? statusIn.map((status) => status.toLowerCase()) : [],
          prStatusIn: prStatusIn ? prStatusIn.map((status) => status.toLowerCase()) : [],
          after: this.$getGQLAfter(currentPageNumber, limit),
          limit,
          q
        },
        refetch
      )
      return response.data.repository?.autofixRuns
    },

    async fetchPendingAutofixRunList({
      provider,
      owner,
      name,
      currentPageNumber,
      limit,
      statusIn,
      prStatusIn,
      refetch,
      q
    }: AutofixListArgs): Promise<Maybe<AutofixRunConnection> | undefined | null> {
      const prStatusList = prStatusIn?.length
        ? prStatusIn.map((status) => status.toLowerCase())
        : [
            AutofixRunPullRequestStatus.Pnc.toLowerCase(), // Not created
            AutofixRunPullRequestStatus.Pro.toLowerCase(), // Pull request open
            AutofixRunPullRequestStatus.Prp.toLowerCase() // In Progress
          ]

      const statusList = statusIn?.length
        ? statusIn.map((status) => status.toLowerCase())
        : [
            AutofixRunStatus.Pass.toLowerCase(), // PASSED
            AutofixRunStatus.Pend.toLowerCase() // PENDING
          ]

      const response: GraphqlQueryResponse = await this.$fetchGraphqlData(
        RepositoryAutofixRunListGQLQuery,
        {
          provider: this.$providerMetaMap[provider].value,
          owner,
          name,
          prStatusIn: prStatusList,
          statusIn: statusList,
          after: this.$getGQLAfter(currentPageNumber, limit),
          limit,
          q
        },
        refetch
      )
      return response.data.repository?.autofixRuns
    }
  }
})
